// extracted by mini-css-extract-plugin
module.exports = {"title":"_5bPw9r56","article":"dUiFD5Wz"};